import axios from 'axios'
const state = {
    termTypes: [],
    tableOptions: {
        tableHeaders: [],
        tableData: [],
        accessTableData: [],
        loading: false,
        tableMeta: {
            total: 10,
            page: 1,
        },
    }
};
const getters = {
    getTermTypes(state) {
        return state.termTypes
    },
    getTableOptions(state) {
        return state.tableOptions
    },
};

const mutations = {
    setTermTypes(state, termTypes) {
        state.termTypes = termTypes
    },
    setLoading(state, status) {
        state.tableOptions.loading = status
    },
    setTableData(state, tableInfo) {
        state.tableOptions.tableHeaders = tableInfo.tableHeaders
        state.tableOptions.tableData = tableInfo.tableData
        state.tableOptions.accessTableData = tableInfo.accessTableData
        state.tableOptions.tableMeta.total = tableInfo.tableMeta.total
        state.tableOptions.tableMeta.page = tableInfo.tableMeta.page
    }
};

const actions = {
    async fetchTermTypes({ commit }, queryParams) {
        try {
            commit('setLoading', true)
            let params = {
                size: 10,
                name: queryParams.nameSearch,
            };
            if (queryParams.paginationValue) {
                params.page = queryParams.paginationValue;
            }
            if (!queryParams.nameSearch) {
                delete params.name;
            }
            const response = await axios.get("/term-type", {
                params,
            });
            commit('setTableData', {
                tableHeaders: ["id", "name", "settings"],
                tableData: response.data.term_types,
                accessTableData: [["id"], ["name"]],
                tableMeta: {
                    total: response.data.meta.total,
                    page: response.data.meta.current_page,
                },
            })
        } catch (err) {
            console.log('err', err);
        } finally {
            commit('setLoading', false)
        }
    },
    async fetchAllTermTypes({ commit }) {
        try {
            const termTypes = await axios.get("/term-type", {
                params: {
                    size: 100000,
                },
            });
            commit('setTermTypes', termTypes.data.term_types)
        }
        catch (err) { }
        finally { }
    },

}



export default {
    state,
    getters,
    mutations,
    actions,
    namespaced: true
}